import React from "react";

const ActiveIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 16C9.55058 16 10.5909 15.7931 11.5615 15.391C12.5321 14.989 13.414 14.3997 14.1569 13.6569C14.8997 12.914 15.489 12.0321 15.891 11.0615C16.2931 10.0909 16.5 9.05058 16.5 8C16.5 6.94943 16.2931 5.90914 15.891 4.93853C15.489 3.96793 14.8997 3.08601 14.1569 2.34315C13.414 1.60028 12.5321 1.011 11.5615 0.608964C10.5909 0.206926 9.55058 -1.56548e-08 8.5 0C6.37827 3.16163e-08 4.34344 0.842855 2.84315 2.34315C1.34285 3.84344 0.5 5.87827 0.5 8C0.5 10.1217 1.34285 12.1566 2.84315 13.6569C4.34344 15.1571 6.37827 16 8.5 16ZM8.29378 11.2356L12.7382 5.90222L11.3729 4.76444L7.55067 9.35022L5.57289 7.37156L4.316 8.62844L6.98267 11.2951L7.67067 11.9831L8.29378 11.2356Z"
        fill="#34A853"
      />
    </svg>
  );
};

export default ActiveIcon;
